import { createSelector } from 'reselect';

import { initialState } from '../../reducer';

const globalState = state => state.global || initialState;

const selectTrade = id => createSelector(globalState, dataState => dataState.get('trades').get(id));

export { selectTrade };
